//  Create the table for the printout for singles and board game events
export function createTable(_pairings, _players, _type) {
  const _table = [];
  let _numOfPlayers = 0;

  if (!_pairings || !_pairings.length)
    return { _table, _numOfPlayers, _numOfTeams: 0 };

  let _playerDict = {};
  if (_players?.length) {
    for (let player of _players) {
      _playerDict[player.id] = player?.total_metrics?.[0]?.value;
    }
  }

  // Singles Event
  _pairings.forEach((pairing) => {
    if (pairing?.player1) {
      const p1 = {
        table: pairing?.table,
        player: {
          name: `${pairing?.player1?.user?.firstName ? pairing.player1.user.firstName : "---"} ${pairing?.player1?.user?.lastName ? pairing.player1.user.lastName : "---"}`.trim(),
          firstName: pairing?.player1?.user?.firstName
            ? pairing.player1.user.firstName
            : "---",
          lastName: pairing?.player1?.user?.lastName
            ? pairing.player1.user.lastName
            : "---",
          id: pairing?.player1?.id,
          points:
            pairing?.player1Game?.points !== undefined
              ? pairing.player1Game.points
                : "---"
        }
      };

      if (pairing?.player2) {
        const p2 = {
          table: pairing?.table,
          player: {
            name: `${pairing?.player2?.user?.firstName ? pairing.player2.user.firstName : "---"} ${pairing?.player2?.user?.lastName ? pairing.player2.user.lastName : "---"}`.trim(),
            firstName: pairing?.player2?.user?.firstName
              ? pairing.player2.user.firstName
              : "---",
            lastName: pairing?.player2?.user?.lastName
              ? pairing.player2.user.lastName
              : "---",
            id: pairing?.player2?.id,
            points:
              pairing?.player2Game?.points !== undefined
                ? pairing.player2Game.points
                  : "---"
          }
        };

        // Set the opponent for each player
        p2.opponent = {
          name: p1.player.name,
          firstName: p1.player.firstName,
          lastName: p1.player.lastName,
          id: p1.player.id,
          points: p1.player.points
        };
        p1.opponent = {
          name: p2.player.name,
          firstName: p2.player.firstName,
          lastName: p2.player.lastName,
          id: p2.player.id,
          points: p2.player.points
        };

        if (_type !== "tableNumber") _table.push(p2);
        _numOfPlayers++;
      }

      _table.push(p1);
      _numOfPlayers++;
    }
  });

  // Sort the table based on the type
  if (_type === "tableNumber") {
    // Sort by table number, then by player name
    _table.sort((a, b) => {
      if (a.table !== b.table) {
        return a.table - b.table;
      }

      const nameA = a.player.name.toLowerCase();
      const nameB = b.player.name.toLowerCase();

      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });
  } else if (_type === "lastName") {
    // Sort by last name, then by first name
    _table.sort((a, b) => {
      const lastNameA = a?.player?.lastName?.toLowerCase();
      const lastNameB = b?.player?.lastName?.toLowerCase();
      const firstNameA = a?.player?.firstName?.toLowerCase();
      const firstNameB = b?.player?.firstName?.toLowerCase();

      if (lastNameA < lastNameB) return -1;
      if (lastNameA > lastNameB) return 1;
      if (firstNameA < firstNameB) return -1;
      if (firstNameA > firstNameB) return 1;
      return 0;
    });
  } else if (_type === "firstName") {
    // Sort by first name, then by last name
    _table?.sort((a, b) => {
      const firstNameA = a?.player?.firstName?.toLowerCase();
      const firstNameB = b?.player?.firstName?.toLowerCase();
      const lastNameA = a?.player?.lastName?.toLowerCase();
      const lastNameB = b?.player?.lastName?.toLowerCase();

      if (firstNameA < firstNameB) return -1;
      if (firstNameA > firstNameB) return 1;
      if (lastNameA < lastNameB) return -1;
      if (lastNameA > lastNameB) return 1;
      return 0;
    });
  }

  _table.unshift({ isHeader: true, type: _type });

  return { _table, _numOfPlayers, _numOfTeams: 0 };
}

// Create the table for the printout for seated events
export function createSeatedTable(_pairings, _players, _type) {
  const _table = [];
  let _numOfPlayers = 0;

  if (!_pairings || !_pairings.length)
    return { _table, _numOfPlayers, _numOfTeams: 0 };

  let _playerDict = {};
  if (_players?.length) {
    for (let player of _players) {
      _playerDict[player.id] = player?.total_metrics?.[0]?.value;
    }
  }

  // Board Game Event
  _pairings.forEach((pairing) => {
    pairing.seatedPlayers.forEach((player) => {
      _table.push({
        table: pairing?.table,
        player: {
          name: player?.playerName,
          firstName: player?.playerName?.split(" ")?.[0]?.trim(),
          lastName: player?.playerName?.split(" ")?.slice(1)?.join(" ")?.trim(),
          id: player?.playerId,
          points:
            _playerDict?.[player?.playerId] !== undefined
              ? _playerDict?.[player?.playerId]
              : "---",
          result:
            typeof pairing?.games?.[player?.playerId]?.gameResult === "number"
              ? pairing.games[player.playerId].gameResult === 2
                ? "Win"
                : pairing.games[player.playerId].gameResult === 0
                  ? "Loss"
                  : "Draw"
              : "---",
          seatName: player?.seatName || ""
        }
      });

      _numOfPlayers++;
    });
  });

  // Sort the table based on the type
  if (_type === "tableNumber") {
    // Sort by table number, then by player name
    _table.sort((a, b) => {
      if (a.table !== b.table) {
        return a.table - b.table;
      }

      const nameA = a.player.name.toLowerCase();
      const nameB = b.player.name.toLowerCase();

      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });
  } else if (_type === "lastName") {
    // Sort by last name, then by first name
    _table.sort((a, b) => {
      const lastNameA = a?.player?.lastName?.toLowerCase();
      const lastNameB = b?.player?.lastName?.toLowerCase();
      const firstNameA = a?.player?.firstName?.toLowerCase();
      const firstNameB = b?.player?.firstName?.toLowerCase();

      if (lastNameA < lastNameB) return -1;
      if (lastNameA > lastNameB) return 1;
      if (firstNameA < firstNameB) return -1;
      if (firstNameA > firstNameB) return 1;
      return 0;
    });
  } else if (_type === "firstName") {
    // Sort by first name, then by last name
    _table?.sort((a, b) => {
      const firstNameA = a?.player?.firstName?.toLowerCase();
      const firstNameB = b?.player?.firstName?.toLowerCase();
      const lastNameA = a?.player?.lastName?.toLowerCase();
      const lastNameB = b?.player?.lastName?.toLowerCase();

      if (firstNameA < firstNameB) return -1;
      if (firstNameA > firstNameB) return 1;
      if (lastNameA < lastNameB) return -1;
      if (lastNameA > lastNameB) return 1;
      return 0;
    });
  }

  _table.unshift({ isHeader: true, type: _type });

  return { _table, _numOfPlayers, _numOfTeams: 0 };
}

//  Create the table for the printout for team events
export function createTeamTable(_pairings, _players, _type) {
  let _table = [];
  let _numOfPlayers = 0;
  let _numOfTeams = 0;

  if (!_pairings || !_pairings?.teamPairings?.length)
    return { _table, _numOfPlayers, _numOfTeams };

  const teamPairings = _pairings?.teamPairings || [];
  const pairings = _pairings?.pairings || [];

  let _teamPlayerDict = {};
  if (_players?.teamPlayers?.length) {
    for (let player of _players.teamPlayers) {
      _teamPlayerDict[player.id] = player?.total_metrics?.[0]?.value;
    }
  }
  let _playerDict = {};
  if (_players?.players?.length) {
    for (let player of _players.players) {
      _playerDict[player.id] = player?.total_metrics?.[0]?.value;
    }
  }

  // Combine pairings with team pairings
  pairings.forEach((pairing) => {
    teamPairings.forEach((teamPairing) => {
      if (pairing?.teamPairingId === teamPairing?.id) {
        if (teamPairing?.pairings?.length) {
          teamPairing.pairings.push(pairing);
        } else {
          teamPairing.pairings = [pairing];
        }
      }
    });

    if (pairing?.player1?.id) {
      _numOfPlayers++;
    }

    if (pairing?.player2?.id) {
      _numOfPlayers++;
    }
  });

  // Create the table rows for each team pairing
  // Helper to create simplified player object
  const makePlayer = (player) => ({
    id: player?.id,
    name:
      `${player?.user?.firstName || ""} ${player?.user?.lastName || ""}`.trim() ||
      "",
    points:
      _playerDict?.[player?.id] !== undefined
        ? _playerDict?.[player?.id]
        : "---"
  });

  // Helper to create simplified team player object
  const makeTeamPlayer = (teamPlayer) => ({
    id: teamPlayer?.id,
    name: teamPlayer?.name || "",
    points:
      _teamPlayerDict?.[teamPlayer?.id] !== undefined
        ? _teamPlayerDict?.[teamPlayer?.id]
        : "---"
  });

  // Helper to create simplified pairing object
  const makePairing = (pairing, swap = false) => ({
    id: pairing?.id,
    table: pairing?.table,
    player1: swap
      ? makePlayer(pairing?.player2, pairing?.player2Game)
      : makePlayer(pairing?.player1, pairing?.player1Game),
    player2: swap
      ? makePlayer(pairing?.player1, pairing?.player1Game)
      : makePlayer(pairing?.player2, pairing?.player2Game)
  });

  // Main logic
  teamPairings.forEach((teamPairing) => {
    if (teamPairing?.teamPlayer1?.id) _numOfTeams++;
    if (teamPairing?.teamPlayer2?.id) _numOfTeams++;

    // Default order
    const simplifiedPairingObj = {
      id: teamPairing?.id,
      table: teamPairing?.table,
      teamPlayer1: makeTeamPlayer(
        teamPairing?.teamPlayer1,
        teamPairing?.player1Game
      ),
      teamPlayer2: makeTeamPlayer(
        teamPairing?.teamPlayer2,
        teamPairing?.player2Game
      ),
      pairings: (teamPairing?.pairings || [])
        .map((pairing) => makePairing(pairing))
        .filter((p) => p.id)
    };
    _table.push(simplifiedPairingObj);

    // Swapped order for "teamName" type
    if (_type === "teamName") {
      const simplifiedPairingObj2 = {
        id: teamPairing?.id,
        table: teamPairing?.table,
        teamPlayer1: makeTeamPlayer(
          teamPairing?.teamPlayer2,
          teamPairing?.player2Game
        ),
        teamPlayer2: makeTeamPlayer(
          teamPairing?.teamPlayer1,
          teamPairing?.player1Game
        ),
        pairings: (teamPairing?.pairings || [])
          .map((pairing) => makePairing(pairing, true))
          .filter((p) => p.id)
      };
      _table.push(simplifiedPairingObj2);
    }
  });

  // Sort the table based on the type
  if (_type === "teamName") {
    // Sort by team name, then by player name
    _table.sort((a, b) => {
      const teamNameA = a?.teamPlayer1?.name?.toLowerCase();
      const teamNameB = b?.teamPlayer1?.name?.toLowerCase();
      if (teamNameA < teamNameB) return -1;
      if (teamNameA > teamNameB) return 1;

      return 0;
    });

    // Sort pairings within each team by player name
    _table.forEach((row) => {
      row.pairings.sort((a, b) => {
        const playerNameA = a?.player1?.name?.toLowerCase() || "";
        const playerNameB = b?.player1?.name?.toLowerCase() || "";
        if (playerNameA < playerNameB) return -1;
        if (playerNameA > playerNameB) return 1;
        return 0;
      });
    });
  } else if (_type === "tableNumber") {
    // Sort by table number, then by team name
    _table.sort((a, b) => {
      const tableA = a?.table;
      const tableB = b?.table;
      if (tableA !== tableB) return tableA - tableB;

      const teamNameA = a?.teamPlayer1?.name?.toLowerCase();
      const teamNameB = b?.teamPlayer1?.name?.toLowerCase();
      if (teamNameA < teamNameB) return -1;
      if (teamNameA > teamNameB) return 1;

      return 0;
    });
  }

  _table.unshift({ isHeader: true, type: _type });

  return { _table, _numOfPlayers, _numOfTeams };
}

//  Create the table for the printout for team events
export function createDoublesTable(_pairings, _players, _type) {
  const _table = [];
  let _numOfPlayers = 0;
  let _numOfTeams = 0;

  if (!_pairings || !_pairings?.length)
    return { _table, _numOfPlayers, _numOfTeams };

  let _teamPlayerDict = {};
  if (_players?.length) {
    for (let player of _players) {
      _teamPlayerDict[player.id] = player?.total_metrics?.[0]?.value;
    }
  }

  _pairings.forEach((pairing) => {
    if (pairing?.teamPlayer1) {
      const teamPlayer1 = {
        name: pairing?.teamPlayer1?.name,
        players: pairing?.teamPlayer1?.players || [],
        id: pairing?.teamPlayer1?.id,
        table: pairing?.table,
        points:
          _teamPlayerDict[pairing?.teamPlayer1?.id] !== undefined
            ? _teamPlayerDict[pairing?.teamPlayer1?.id]
            : "---"
      };

      if (pairing?.teamPlayer2) {
        const teamPlayer2 = {
          name: pairing?.teamPlayer2?.name,
          players: pairing?.teamPlayer2?.players || [],
          id: pairing?.teamPlayer2?.id,
          table: pairing?.table,
          points:
            _teamPlayerDict[pairing?.teamPlayer2?.id] !== undefined
              ? _teamPlayerDict[pairing?.teamPlayer2?.id]
              : "---"
        };

        // Set the opponent for each team player
        teamPlayer2.opponent = {
          name: teamPlayer1.name,
          players: teamPlayer1.players,
          id: teamPlayer1.id,
          table: teamPlayer1.table,
          points: teamPlayer1.points
        };

        teamPlayer1.opponent = {
          name: teamPlayer2.name,
          players: teamPlayer2.players,
          id: teamPlayer2.id,
          table: teamPlayer2.table,
          points: teamPlayer2.points
        };

        if (_type !== "tableNumber") _table.push(teamPlayer2);
        _numOfPlayers += teamPlayer2.players.length;
        _numOfTeams++;
      }

      _table.push(teamPlayer1);

      _numOfPlayers += teamPlayer1.players.length;
      _numOfTeams++;
    }
  });

  // Sort the table based on the type
  if (_type === "teamName") {
    // Sort by team name, then by player name
    _table.sort((a, b) => {
      const teamNameA = a?.name?.toLowerCase();
      const teamNameB = b?.name?.toLowerCase();
      if (teamNameA < teamNameB) return -1;
      if (teamNameA > teamNameB) return 1;
      // If team names are the same, sort by first player name
      const playerNameA = a?.players?.[0]?.name?.toLowerCase() || "";
      const playerNameB = b?.players?.[0]?.name?.toLowerCase() || "";
      if (playerNameA < playerNameB) return -1;
      if (playerNameA > playerNameB) return 1;
      return 0;
    });
  } else if (_type === "tableNumber") {
    // Sort by table number, then by team name
    _table.sort((a, b) => {
      const tableA = a?.table;
      const tableB = b?.table;
      if (tableA !== tableB) return tableA - tableB;
      const teamNameA = a?.name?.toLowerCase();
      const teamNameB = b?.name?.toLowerCase();
      if (teamNameA < teamNameB) return -1;
      if (teamNameA > teamNameB) return 1;
      return 0;
    });
  }

  _table.unshift({ isHeader: true, type: _type });

  return { _table, _numOfPlayers, _numOfTeams };
}
